import React from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box, Link } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

function Navbar() {
  const history = useHistory();
  const { user, logout, isAffiliate } = useAuth();
  
  const handleLogout = async () => {
    await logout();
    history.push('/');
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Link
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit'
          }}
        >
          <Typography variant="h6" component="div">
            drainer.bot
          </Typography>
        </Link>
        <Box>
          {!user ? (
            <>
              <Button color="inherit" component={RouterLink} to="/login">
                Login
              </Button>
              <Button color="inherit" component={RouterLink} to="/register">
                Register
              </Button>
              <Button color="inherit" component={RouterLink} to="/news">
                News
              </Button>
              <Button color="inherit" component={RouterLink} to="/faq">
                FAQ
              </Button>
            </>
          ) : (
            <>
              <Button color="inherit" component={RouterLink} to="/profile">
                Profile
              </Button>
              <Button color="inherit" component={RouterLink} to="/credits">
                Credits
              </Button>
              <Button color="inherit" component={RouterLink} to="/crypt">
                Crypt
              </Button>
              {isAffiliate && (
                <Button color="inherit" component={RouterLink} to="/affiliate">
                  Affiliate
                </Button>
              )}
              {user.is_admin && (
                <Button color="inherit" component={RouterLink} to="/admin">
                  Admin
                </Button>
              )}
              <Button color="inherit" component={RouterLink} to="/support">
                Support
              </Button>
              <Button color="inherit" component={RouterLink} to="/news">
                News
              </Button>
              <Button color="inherit" component={RouterLink} to="/faq">
                FAQ
              </Button>
              <Button color="inherit" onClick={handleLogout}>
                Logout
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar; 